import { useGetEditOrActual } from '../../CampaignSettings/selectors/useGetEditOrActual';
import { SplitTestScheduling } from '../../../../../../../types/scheduling';

export const useSchedulingSelector = ({ splitTestId }: { splitTestId: string }) => {
  const state = useGetEditOrActual();

  return state.splitTests[splitTestId]?.scheduling ?? ({} as SplitTestScheduling);
};
